import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Grid, IconButton, TextField, Tooltip } from '@mui/material';
import React, { useMemo } from 'react';
import { useClipboard } from 'use-clipboard-copy';
import YAML from 'yaml';

import { ClassConfigYamlSchema, Model } from 'interfaces/model';
import { generateClassConfigFromForm } from './helpers';

interface Props {
  disabledTrainingTargets: string[];
  trainingClassToAnnotationOptions: Record<string, string[]>;
  modelDetailsResponse?: Model;
}

export const ClassConfigYamlPreview: React.FC<Props> = ({
  modelDetailsResponse,
  disabledTrainingTargets,
  trainingClassToAnnotationOptions,
}) => {
  const classesConfigFromModel = modelDetailsResponse?.meta?.deps?.classesConfig;

  const newClassConfig: Record<string, ClassConfigYamlSchema> = useMemo(
    () =>
      generateClassConfigFromForm({
        classesConfigFromModel,
        trainingClassToAnnotationOptions,
        disabledTrainingTargets,
      }),
    [trainingClassToAnnotationOptions, classesConfigFromModel, disabledTrainingTargets]
  );

  const classConfigYaml = useMemo(() => YAML.stringify(newClassConfig), [newClassConfig]);
  const clipboard = useClipboard({ copiedTimeout: 1000 });

  const handleCopy = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    clipboard.copy(classConfigYaml);
  };
  return (
    <Grid item sx={{ position: 'relative' }}>
      <TextField multiline fullWidth minRows={4} maxRows={8} value={classConfigYaml} />
      <Tooltip title={clipboard.copied ? 'Copied!' : 'Click to copy'} placement="top">
        <IconButton
          sx={{
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
          }}
          onClick={handleCopy}
          color="inherit"
        >
          <ContentCopyIcon />
        </IconButton>
      </Tooltip>
    </Grid>
  );
};
